import { EventItem, PathData, RaceDetails } from '../../data-types/sports/sportsInterfaces';
import { store } from '../store';
import {
  LOADING_EVENTS,
  SET_DETAILED_EVENT,
  SET_IS_SUPERCHARGED_BET_TICKER_VISIBLE,
  SET_LAST_SEEN_SPORT_PAGE,
  SET_RACE,
  SET_TRIGGER_SPORRTSBOOK_RESUBSCRIPTIONS,
} from '../types/sportsbookTypes';

export const setDetailedEvent = (event: EventItem | undefined) => {
  store.dispatch({
    type: SET_DETAILED_EVENT,
    meta: event,
  });
};

export const setRace = (race: RaceDetails | undefined) => {
  store.dispatch({
    type: SET_RACE,
    meta: race,
  });
};

export const setLoadingEvents = (meta: boolean) => {
  store.dispatch({
    meta,
    type: LOADING_EVENTS,
  });
};

export const setIsSuperchargedBetTickerVisible = (meta: boolean) => {
  store.dispatch({
    meta,
    type: SET_IS_SUPERCHARGED_BET_TICKER_VISIBLE,
  });
};

export const setTriggerSportsbookResubscriptions = (meta: boolean) => {
  store.dispatch({
    meta,
    type: SET_TRIGGER_SPORRTSBOOK_RESUBSCRIPTIONS,
  });
};

export const setLastSeenSportPage = (meta: PathData) => {
  store.dispatch({
    meta,
    type: SET_LAST_SEEN_SPORT_PAGE,
  });
};
